<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/home']">Home</a></li>
      <li class="breadcrumb-item"><a [routerLink]="['/smart-irrigation/regions']">Smart Irrigation</a></li>
      <li class="breadcrumb-item"><a [routerLink]="['/smart-irrigation/parks', nodeId]">{{ node?.name || 'Parks' }}</a></li>
      <li class="breadcrumb-item"><a (click)="goBack()" style="cursor:pointer">Site Dashboard</a></li>
      <li class="breadcrumb-item active"><strong>{{ stationName }}</strong></li>
    </ol>
  </div>
  <div class="col-lg-2 d-flex align-items-center justify-content-end gap-2">
    <small class="text-muted" *ngIf="lastRefresh">{{ lastRefresh | date:'d MMM yyyy HH:mm' }}</small>
    <button class="btn btn-outline-white btn-sm" (click)="load()" [disabled]="loading" title="Refresh">
      <i class="fa fa-sync" [class.fa-spin]="loading"></i>
    </button>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight pt-3">
  <div class="alert alert-info" *ngIf="loading">
    <i class="fa fa-spinner fa-spin me-2"></i> Loading weather data&hellip;
  </div>

  <div class="alert alert-warning" *ngIf="!loading && noData">
    No weather station data found for this site.
    <a (click)="goBack()" style="cursor:pointer" class="alert-link">Go back</a>
  </div>

  <ng-container *ngIf="!loading && !noData">
    <div class="st-summary">
      <div class="st-metric-card st-metric-card--green" title="Wind direction in degrees clockwise from north">
        <div class="st-metric-card__label">Wind Direction</div>
        <div class="st-metric-card__value st-metric-card__wind-direction-value">
          <i class="fa fa-arrow-up" *ngIf="windDirectionDegrees != null"
             [ngStyle]="{ transform: 'rotate(' + windDirectionDegrees + 'deg)' }"
             aria-label="Wind direction"></i>
          <span *ngIf="windDirectionDegrees == null">N/A</span>
        </div>
        <div class="st-metric-card__sub st-metric-card__sub--green">
          {{ windDirectionDegrees != null ? (windDirectionDegrees | number:'1.0-0') + ' degrees' : 'No data' }}
        </div>
      </div>
      <div class="st-metric-card" [ngClass]="'st-metric-card--' + metric.status" *ngFor="let metric of weatherMetrics">
        <div class="st-metric-card__label">{{ metric.label }}</div>
        <div class="st-metric-card__value">{{ metric.value }}<span class="st-metric-card__unit">{{ metric.unit }}</span></div>
        <div class="st-metric-card__sub" [ngClass]="'st-metric-card__sub--' + metric.status">{{ metric.statusLabel }}</div>
      </div>
    </div>

    <div class="st-chart-card" *ngIf="temperatureChartOptions">
      <div class="st-chart-card__title">Temperature &#8212; 14-Day History</div>
      <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="temperatureChartOptions" style="width:100%;height:300px;display:block;"></highcharts-chart>
    </div>

    <div class="st-chart-card" *ngIf="humidityChartOptions">
      <div class="st-chart-card__title">Humidity &#8212; 14-Day History</div>
      <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="humidityChartOptions" style="width:100%;height:300px;display:block;"></highcharts-chart>
    </div>

    <div class="st-chart-card" *ngIf="hourlyRainfallChartOptions">
      <div class="st-chart-card__title">Hourly Rainfall &#8212; 14-Day History</div>
      <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="hourlyRainfallChartOptions" style="width:100%;height:300px;display:block;"></highcharts-chart>
    </div>

    <div class="st-chart-card" *ngIf="windSpeedChartOptions">
      <div class="st-chart-card__title">Wind Speed &#8212; 14-Day History</div>
      <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="windSpeedChartOptions" style="width:100%;height:300px;display:block;"></highcharts-chart>
    </div>

    <div class="st-trend-note st-trend-note--muted" *ngIf="!temperatureChartOptions && !humidityChartOptions && !rainfallChartOptions && !windSpeedChartOptions">
      No historical weather data is available for this period.
    </div>
  </ng-container>
</div>
